import { useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import Action from '../shared/Action/Action';
import Header from '../shared/Header/Header';
import BannerCarousel from './bannerCarousel/BannerCarousel';
import PromoProducts from './promoProducts/PromoProducts';
import BannerInfo from './bannerInfo/BannerInfo';
import Footer from '../shared/Footer/Footer';
import useIsLTE650 from '../../hooks/useIsLTE650';
import { YM_ID } from '../metrics/ym';
import './homePage.scss';

const HomePage: React.FC = () => {
    const isMobile = useIsLTE650(650);
    const navigate = useNavigate();
    const goToCatalogLockedRef = useRef(false);

    const handleGoToCatalogClick: React.MouseEventHandler<HTMLAnchorElement> = (e) => {
        const goalId = 'click_button_go_to_catalog';
        const counterId = YM_ID || 103250323;
        if (process.env.NODE_ENV !== 'production') return;
        if (goToCatalogLockedRef.current) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        goToCatalogLockedRef.current = true;
        e.preventDefault();
        e.stopPropagation();
        let navigated = false;
        const go = () => {
            if (navigated) return;
            navigated = true;
            navigate('/catalog');
        };
        try {
            window.ym?.(counterId, 'reachGoal', goalId, {}, go);
        } catch {
            // ignore
        }
        window.setTimeout(() => {
            go();
        }, 900);
    };

    return (
        <div className="homePage">
            <Helmet>
                <title>Купить шелковые подушки и одеяла - производство S-Gabai</title>
                <meta
                    name="description"
                    content="Купить шелковые подушки и одеяла от производителя. Натуральный шелк Tussah и Mulberry, гипоаллергенный текстиль. Производство S-Gabai, доставка по РФ."
                />
            </Helmet>
            <Header isMobile={isMobile} />
            <main className="homePage__main">
                <h1 className="homePage__visuallyHidden">Шелковые подушки и одеяла S-Gabai - премиум-текстиль для здорового сна</h1>
                <BannerCarousel isMobile={isMobile} />
                <div className="homePage__main_scrollHint" aria-hidden="true">
                    <span />
                </div>
            </main>
            <div className="homePage__info">
                <Action as="link" to="/catalog" variant="outline" extraClass="homePage__info_сatalogLink" onClick={handleGoToCatalogClick}>
                    Смотреть каталог
                </Action>
                {/* <p className="homePage__info_text">
                    Ищете, где купить шёлковые подушки и одеяла? S-Gabai — это прямой производитель одеял и подушек из натурального шёлка. Мы используем шёлк Тусса,
                    Малбери и Голд — дышащие и гипоаллергенные материалы, идеально подходящие для дома, отелей и гостиниц.
                </p>
                <p className="homePage__info_text">
                    Каждое одеяло и подушка из шелкопряда изготавливаются на нашем производстве с точным контролем качества. Шёлковое волокно обеспечивает комфорт в
                    любое время года: сохраняет тепло зимой и дарит прохладу летом.
                </p>
                <p className="homePage__info_text">Выбирайте настоящую заботу о себе — выбирайте S-Gabai.</p> */}
                <p className="homePage__info_text">
                    Ищете, где купить шёлковые подушки и одеяла? S-Gabai — это прямой производитель одеял и подушек из натурального шёлка. Мы используем шёлк Тусса,
                    Малбери и Голд — дышащие и гипоаллергенные материалы, идеально подходящие для дома, отелей и гостиниц.
                </p>
                <p className="homePage__info_text">
                    Каждое одеяло и подушка из шелка изготавливаются на нашем производстве с точным контролем качества. Шёлковое волокно обеспечивает комфорт в любое
                    время года: сохраняет тепло зимой и дарит прохладу летом.
                </p>
                <p className="homePage__info_text">Выбирайте настоящую заботу о себе — выбирайте S-Gabai.</p>
            </div>
            <PromoProducts isMobile={isMobile} />
            <BannerInfo isMobile={isMobile} />
            <Footer isMobile={isMobile} />
        </div>
    );
};

export default HomePage;
